import { render, staticRenderFns } from "./PaymentStatus.vue?vue&type=template&id=2c97b70c&"
import script from "./PaymentStatus.vue?vue&type=script&lang=ts&"
export * from "./PaymentStatus.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports